export default Object.freeze({
  ENDPOINT: "https://mask-api.playtwo.net/get",
  // ENDPOINT: "http://localhost:8080/get",
})




// WEBPACK FOOTER //
// ./src/constants.js